import ApiService from '../../services/ApiService'
import _ from 'lodash'
import axios from 'axios'
import { azureAD } from '@/const'
import store from '@/store/store'
import swal from 'sweetalert'
import Vue from 'vue'
import { app } from '@/main.js'
import moment from 'moment'

export const namespaced = true
export const state = {
  loggedInUser: null,
  permissions: [],
  loading: 0,
  no_token_request: [
    '/api/user/login',
    '/setting/getcustomtheme',
    '/membershipv2/createuserv2',
    '/organisation/VerifyInvitation?invitationToken'
  ],
  no_loading_request: [
    '/Board/GetAllPodsStatus',
    '/Board/CheckConnection',
    '/data/GetConsents',
    '/Board/GetPatient',
    '/BioRecord/GetBioPodRecord',
    '/api/user/RefreshTokenv2',
    '/site/GetUserSite',
    '/AddToGroup',
    '/membershipv2/GetAllPatientsV3',
    '/Board/GetPatientProfile'
  ],
  logout_request: '/api/user/Logout',
  token_refreshing: false,
  is_internet_error: false,
  tokenInfo: null,
  currentPolicy: null
}

export const mutations = {
  SET_TOKEN_REFRESH: (state, token_refreshing) => {
    state.token_refreshing = token_refreshing
  },
  SET_LOADING: (state, loading) => {
    state.loading = state.loading + loading
  },
  STOP_LOADING: state => {
    state.loading = 0
  },
  SET_USER_DATA(state, userData) {
    state.loggedInUser = userData
    if (userData) {
      localStorage.setItem('user', JSON.stringify(userData))
    } else {
      localStorage.removeItem('user')
    }
  },
  SET_TOKEN_INFO(state, tokenInfo) {
    state.tokenInfo = tokenInfo
    if (tokenInfo) {
      localStorage.setItem('tokenInfo', JSON.stringify(tokenInfo))
    } else {
      localStorage.removeItem('tokenInfo')
    }
  },
  SET_PERMISSIONS(state, permissions) {
    _.assignIn(state, permissions)
    if (permissions) {
      localStorage.setItem('permissions', JSON.stringify(permissions))
    } else {
      localStorage.removeItem('permissions')
    }
  },
  SET_IS_INTERNET_ERROR: (state, is_internet_error) => {
    state.is_internet_error = is_internet_error
  },
  SET_POLICY: (state, currentPolicy) => {
    state.currentPolicy = currentPolicy
    if (currentPolicy) {
      localStorage.setItem('currentPolicy', currentPolicy)
    } else {
      localStorage.removeItem('currentPolicy')
    }
  }
}

export const getters = {
  auth: () => module =>
    _.includes(JSON.parse(localStorage.getItem('permissions')), module),
  selecteOrganisationId: () => {
    const user = state.loggedInUser
    if (!user) return null
    const selectedOrganisation = user.organisations.filter(item => item.Active)
    if (selectedOrganisation && selectedOrganisation.length) {
      return selectedOrganisation[0].OrganisationName.OrganisationId
    }
    return null
  },
  selecteOrganisationName: state => {
    const user = state.loggedInUser
    if (!user) return null
    const selectedOrganisation = user.organisations.filter(item => item.Active)
    if (selectedOrganisation && selectedOrganisation.length) {
      return selectedOrganisation[0].OrganisationName.Name
    }
    return null
  },
  userOwnedOrganisations: state => {
    const user = state.loggedInUser
    if (!user) return []
    return user.organisations
  },
  displayName: state => {
    const user = state.loggedInUser
    if (!user) return []
    return user.displayName
  }
}

export const actions = {
  login({ commit }, credentials) {
    return new Promise((resolve, reject) => {
      ApiService.loginUser(credentials)
        .then(response => {
          let userData = {
            id: response.data.UserId ? response.data.UserId : '',
            username: credentials.username,
            email: response.data.Email,
            retentionPeriod: response.data.RetentionPeriod,
            systemRetentionPeriod: response.data.SystemRetentionPeriod,
            groups: response.data.Groups,
            selectedGroups: response.data.Groups.map(item => {
              return item.GroupId
            })
          }
          commit('SET_USER_DATA', userData)
          store.commit('user/SET_TOKEN_INFO', {
            access_token: response.data.token
              ? response.data.token
              : response.data.Token,
            refresh_token: response.data.RefreshToken,
            expires_on:
              (response.data.ExpiresAt - 621355968000000000) / 10000000
          })

          //set permissions
          let permissions = []
          if (response.data.Roles && response.data.Roles.length) {
            response.data.Roles.forEach(role => {
              role.Modules.forEach(module => {
                if (module.ChildModules.length) {
                  module.ChildModules.forEach(childModule => {
                    if (childModule.ChildModules.length) {
                      childModule.ChildModules.forEach(subModule => {
                        subModule.Permissions.forEach(ele => {
                          if (ele.IsActive) {
                            permissions.push(
                              module.Name +
                                '.' +
                                childModule.Name +
                                '.' +
                                subModule.Name +
                                '.' +
                                ele.Name
                            )
                          }
                        })
                      })
                    } else {
                      childModule.Permissions.forEach(ele => {
                        if (ele.IsActive) {
                          permissions.push(
                            module.Name +
                              '.' +
                              childModule.Name +
                              '.' +
                              ele.Name
                          )
                        }
                      })
                    }
                  })
                } else {
                  module.Permissions.forEach(ele => {
                    if (ele.IsActive) {
                      permissions.push(module.Name + '.' + ele.Name)
                    }
                  })
                }
              })
            })
          }
          permissions = [...new Set(permissions)]
          commit('SET_PERMISSIONS', permissions)
          resolve(response)
        })
        .catch(() => {
          reject(Error('Unknown Error'))
        })
    })
  },
  getAzureToken({ commit }, code) {
    return new Promise((resolve, reject) => {
      axios({
        url: `${azureAD.hostName}/${
          azureAD.tenantName
        }.onmicrosoft.com/${localStorage.getItem('currentPolicy') ||
          azureAD.policy}/oauth2/v2.0/token?grant_type=authorization_code&client_id=${
          azureAD.clientId
        }&scope=https://${
          azureAD.tenantName
        }.onmicrosoft.com/api/read_data offline_access&redirect_uri=https://jwt.ms&code=${code}&code_verifier=${localStorage.getItem(
          'codeVerifier'
        )}`,
        method: 'post'
      })
        .then(response => {
          commit('SET_TOKEN_INFO', response.data)
          resolve(response)
        })
        .catch(error => {
          swal({
            icon: 'error',
            title: app.$i18n.t('text.failed'),
            text: error.response.data.error_description
          })
          reject(Error('Unknown Error'))
        })
    })
  },
  refreshToken({ commit }) {
    let tokenInfo = JSON.parse(localStorage.getItem('tokenInfo'))
    let policy = localStorage.getItem('currentPolicy') || azureAD.policy
    commit('SET_TOKEN_REFRESH', true)
    return new Promise((resolve, reject) => {
      axios({
        url: `${azureAD.hostName}/${azureAD.tenantName}.onmicrosoft.com/${policy}/oauth2/v2.0/token?grant_type=refresh_token&client_id=${azureAD.clientId}&scope=https://${azureAD.tenantName}.onmicrosoft.com/api/read_data offline_access&redirect_uri=https://jwt.ms&refresh_token=${tokenInfo.refresh_token}`,
        method: 'post'
      })
        .then(response => {
          commit('SET_TOKEN_INFO', response.data)
          commit('SET_TOKEN_REFRESH', false)
          resolve(response)
        })
        .catch(() => {
          commit('SET_TOKEN_REFRESH', false)
          reject(Error('Unknown Error'))
        })
    })
  },
  verifyUser({ commit }) {
    return new Promise((resolve, reject) => {
      ApiService.VerifyUser(document.domain)
        .then(response => {
          if (response.data.success) {
            let data = response.data.data
            let userData = {
              username: data.Username,
              displayName: data.DisplayName,
              email: data.Email,
              retentionPeriod: data.RetentionPeriod,
              systemRetentionPeriod: data.SystemRetentionPeriod,
              groups: data.Groups,
              customerType: data.CustomerType,
              manufacturers: data.Manufacturers,
              organisations: data.Organisations
            }
            commit('SET_USER_DATA', userData)

            //set permissions
            if (
              data.Organisations.length &&
              data.Organisations.length === 1 &&
              data.Organisations[0].Roles.length
            ) {
              store.dispatch('user/assignPermission', data.Organisations[0])
            }
          }
          resolve(response)
        })
        .catch(() => {
          reject(Error('Unknown Error'))
        })
    })
  },
  assignPermission({ commit }, selecteOrganisation) {
    let permissions = []
    selecteOrganisation.Roles.forEach(role => {
      role.Modules.forEach(module => {
        if (module.ChildModules.length) {
          module.ChildModules.forEach(childModule => {
            if (childModule.ChildModules.length) {
              childModule.ChildModules.forEach(subModule => {
                subModule.Permissions.forEach(ele => {
                  if (ele.IsActive) {
                    permissions.push(
                      module.Name +
                        '.' +
                        childModule.Name +
                        '.' +
                        subModule.Name +
                        '.' +
                        ele.Name
                    )
                  }
                })
              })
            } else {
              childModule.Permissions.forEach(ele => {
                if (ele.IsActive) {
                  permissions.push(
                    module.Name + '.' + childModule.Name + '.' + ele.Name
                  )
                }
              })
            }
          })
        } else {
          module.Permissions.forEach(ele => {
            if (ele.IsActive) {
              permissions.push(module.Name + '.' + ele.Name)
            }
          })
        }
      })
    })
    permissions = [...new Set(permissions)]
    commit('SET_PERMISSIONS', permissions)

    // Mark the selected organisation
    let user = JSON.parse(localStorage.getItem('user'))
    user.organisations.forEach(organisation => {
      organisation.Active =
        organisation.OrganisationName.OrganisationId ===
        selecteOrganisation.OrganisationName.OrganisationId
    })
    commit('SET_USER_DATA', user)
  },
  logout() {
    window.open(
      `${azureAD.hostName}/${
        azureAD.tenantName
      }.onmicrosoft.com/${localStorage.getItem('currentPolicy') ||
        azureAD.policy}/oauth2/v2.0/logout?post_logout_redirect_uri=${
        window.location.origin
      }/sign-in`,
      '_self'
    )
    localStorage.removeItem('user')
    localStorage.removeItem('tokenInfo')
    localStorage.removeItem('permissions')
    localStorage.removeItem('currentPolicy')
    localStorage.removeItem('codeVerifier')
    Vue.prototype.stopSignalR()
  },
  appLogin({ commit }, accessToken) {
    return new Promise(resolve => {
      let tokenInfo = {
        access_token: accessToken,
        expires_in: 900,
        expires_on: moment()
          .add(900, 's')
          .unix(),
        not_before: moment().unix(),
        profile_info: '',
        refresh_token: '',
        refresh_token_expires_in: '',
        resource: '',
        scope: '',
        token_type: 'Bearer'
      }
      commit('SET_TOKEN_INFO', tokenInfo)
      resolve(tokenInfo)
    })
  }
}
